/* InitialState.ts */

/* Interfaces */
import { AuthSliceProps } from "src/shared/interfaces/common/Auth";

export const initialState: AuthSliceProps = {
  data: {
    isAuthenticated: false,
    expirationTime: null,
  },
  roles: [],
  allowedCareSites: null,
  allowedCareSitesStatus: "idle",
  twoFa: {
    credentials: {
      usernameEmail: "",
      password: "",
    },
    qrCode: undefined,
    qrCodeRequired: false,
    twoFaRequired: false,
  },
  isLoading: false,
  error: undefined,
};
